import classNames from 'classnames'
import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Icon, Typography } from 'shared/ui'
import { TagElement } from 'widgets/TagsDropdown/ui/TagElement/TagElement'
import { useTagsDropdownContext } from 'widgets/TagsDropdown/context/TagsDropdownContext'

import styles from './styles.module.scss'

export const TagsDropdownTrigger = observer(({}) => {
  const {
    controlStore,
    placeholder,
    previewTags,
    extraTagsCount,
    hasExtraTags,
    isFormFieldVariant,
    hideTriggerLeftIcon,
  } = useTagsDropdownContext()

  useEffect(() => {
    controlStore.syncIds()
  }, [])

  const EmptyTrigger = (
    <div className={styles.trigger}>
      {!hideTriggerLeftIcon && (
        <div className={styles.trigger__icon}>
          <Icon icon={'tag'} fontSize={16} tertiary className={styles.triggerIcon} />
        </div>
      )}
      <Typography
        className={classNames(styles.trigger__label, styles['trigger__label--placeholder'])}
        variant={'text-input-field'}
        ariaLabel={'SelectTag'}
      >
        {placeholder || 'Select tag'}
      </Typography>
    </div>
  )

  const FilledTrigger = (
    <div
      className={classNames(styles.tagsPlaceholder, {
        [styles.formField]: isFormFieldVariant,
      })}
      aria-label='AddedTagsListItems'
    >
      {controlStore.synced &&
        previewTags.map((tag) => <TagElement variant={'default'} key={tag.id} tag={tag} />)}
      {hasExtraTags && <TagElement variant={'counter'} count={extraTagsCount} />}
    </div>
  )

  const Trigger = controlStore.hasTags ? FilledTrigger : EmptyTrigger

  return Trigger
})
